import React, { useState } from 'react';
import logo from '../../assets/images/canal_denuncia_fretafi_branco.png';
import { Button, Form, Col, FormGroup } from 'reactstrap';
import * as S from './styled';
import Axios from '../../utils/Axios';
import Footer from '../../components/FooterLogin';
import LogoBancariosRS from '../../assets/images/logo_bancariosrs.png';

const Login = () => {
  const [login, setLogin] = useState();
  const [password, setPassword] = useState();
  const [erro, setErro] = useState(false);

  const handleFormSubmit = async () => {
      await Axios.post(`/auth/login`,{
          login: login,
          password: password,
        }, {
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        if(res.status === 200) {
          localStorage.setItem('token', res.data.token);
          localStorage.setItem('user', res.data.user);
          localStorage.setItem('nome', res.data.nome);
          localStorage.setItem('id', res.data.id);
          localStorage.setItem('acesso', res.data.acesso);
          window.location.href = `${process.env.PUBLIC_URL}/minhas-denuncias`;
        }
      }).catch((res) => {
        if(res.message === "Request failed with status code 401") {
          setErro(true);
          setTimeout(() => { setErro(false); }, 5000);
        }
      })
  };

  return (
    <S.DivBody>
      <S.DivTeste>
        <S.Text2>Um sistema do portal <img src={LogoBancariosRS} alt="Bancarios RS" style={{ marginLeft: "5px" }} /></S.Text2>
      </S.DivTeste>
      <S.Fundo>
      <Col md={6} lg={6}>
        <S.Card>
          <Form>
            <div className="text-center pb-4">
              <img
                src={logo}
                className="rounded"
                style={{ width: 194, height: 67 }}
                alt="logo"
              />
            </div>
            <S.Text style={{ marginBottom: "35px" }}>Acompanhe sua denúncia através do seu protocolo</S.Text>
            <S.DivInput>
              <FormGroup>
                <S.TextLight>
                  Número de protocolo ou e-mail
                </S.TextLight>
                <S.CustomInput2
                  id="login"
                  name="login"
                  type="text"
                  onChange={(e) => setLogin(e.target.value)}
                  value={login}
                />
              </FormGroup>
            </S.DivInput>
            <S.DivInput>
              <FormGroup>
                <S.TextLight>
                  Senha
                </S.TextLight>
                <S.CustomInput2
                  id="password"
                  name="password"
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
              </FormGroup>
            </S.DivInput>
            {/* <S.DivInput>
              <S.DivLabel>
                <Cadeado style={{ width: "40px", height: "40px" }} />
              </S.DivLabel>
              <S.CustomInput
                id="password"
                type={verSenha === false ? "password" : "text"}
                name="password"
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                placeholder="Digite Sua Senha"
                style={{
                  borderBottomColor: 'white',
                  borderBottomWidth: 1,
                  width: '100%'
                }}
              />
              <S.DivLabel onClick={() => setVerSenha(!verSenha)} >
                {verSenha === false ? <OlhoFechado style={{ width: "40px", height: "40px" }} /> : <Olho style={{ width: "40px", height: "40px" }} /> }
              </S.DivLabel>
            </S.DivInput> */}
            {erro && 
              <S.CustomFormText color="white">
                Usuário e/ou senha inválidos.
              </S.CustomFormText>
            }
            <Button size="lg" block color="var(--primary)" style={{ backgroundColor: "#ffffff", border: '1px solid #FFFFFF', borderRadius: '20px', marginTop: '15px' }} onClick={() => handleFormSubmit()}>
              {/* <img src={maiorIcon} alt="" style={{ marginRight: '10px' }} /> */}
              <S.TextLogin>ACESSAR</S.TextLogin>
            </Button>
            {/* <S.EsqueciSenha>
              <S.CustomCadeado style={{ width: "20px", height: "20px" }} /><S.CustomLink to="/esqueci-senha">Esqueci minha senha</S.CustomLink>
            </S.EsqueciSenha> */}
          </Form>
        </S.Card>
      </Col>
      <Footer />
      </S.Fundo>
      <S.DivTeste>
        <S.Text2>Um sistema do portal <img src={LogoBancariosRS} alt="Bancarios RS" style={{ marginLeft: "5px" }} /></S.Text2>
      </S.DivTeste>
    </S.DivBody>
  );
}

export default Login;